import { getUuid } from "../util";
import request from "./request";

// 获取登录地址
export const reuqestGetLoginLocation = () => {
    return request('get', '/api/auth/account')
}

// 获取token
export const reuqestGetToken = (params: any) => {
    return request('get', `/api/auth/baidu/callback?code=${params.code}&state=${params.state}`)
}

// 获取用户信息
export const reuqestGetUserInfo = () => {
    return request('get', `/api/system/user/_self`)
}

// 退出登录
export const reuqestLogOut = () => {
    return request('get', `/api/auth/logout`)
}

// 普通登录
export const reuqestAuthToken = (params: any) => {
    return request('post', `/api/auth/token`, params)
}

// 手机号验证码登录
export const reuqestLoginPhone = (params: any) => {
    return request('post', `/api/auth/login/phone`, params)
}

// 获取手机验证码
export const reuqestAuthSMSCode = (phone: any) => {
    const uuid = getUuid()
    return request('get', `/api/auth/SMSCode?phone=${phone}&deviceId=${uuid}`)
}

// 注册用户信息
export const reuqestAuthRegister = (params: any) => {
    return request('post', `/api/auth/register`, params)
}

// 绑定百度网盘
export const reuqestBindBaiDu = (code: any, state: any) => {
    return request('get', `/api/system/user/bindBaiDu?code=${code}&state=${state}`)
}

// 绑定手机号
export const reuqestBindPhone = (phone: any, code: any) => {
    return request('get', `/api/system/user/bindPhone?phone=${phone}&code=${code}`)
}

// 手机号校验
export const authCheck = (params: any) => {
    return request('post', `/api/auth/check`, params)
}

// new
// 创建图片验证码
export const verifyImage = (width: number, height: number): any => {
    return request('post', `/api/rubik/account/verify/image?width=${width}&height=${height}`)
}

// 使用用户名密码创建账号
export const accountPasswordUser = (params: any) => {
    return request('post', `/api/rubik/account/password/user`, params)
}

// 发送手机验证码
export const phoneCheckCode = (
    mobile: number | string,
    templateId: string,
    code: string,
    value: string) => {
    return request('post', `/api/rubik/account/mobile/${mobile}/check/code/${templateId}`, {
        code,
        value
    })
}

// 使用手机验证码创建账户
export const accountMobileUser = (params: any) => {
    return request('post', `/api/rubik/account/mobile/user`, params)
}


// 生成外部认证链接
export const providerAuthLink = (provider: string, type: string) => {
    return request('posttxt', `/api/rubik/account/external/${provider}/auth_link/${type}`,
        `${process.env.REACT_APP_WEBSITE}/#/auth`)
}
/**
     * 外部认证结果获取
     * @param {number} stateId 
     * @returns 认证状态结果
     */
export const getExternalAuthResult = (stateId: string) => {
    return request('get', `/api/rubik/account/external/auth/result/${stateId}`)
}
// 发送验证码到邮箱
export const emailCheckCode = (email: string, templateId: string, code: string, value: string) => {
    return request('post', `/api/rubik/account/email/${email}/check/code/${templateId}`, {
        code,
        value
    })
}

// 通过邮箱创建账号
export const accountEmailUser = (params: any) => {
    return request('post', `/api/rubik/account/email/user`, params)
}

// 校验手机号是否存在
export const checkPhone = (mobile: any) => {
    return request('head', `/api/rubik/account/mobile/${mobile}`, null, null, true)
}

// 校验邮箱是否存在
export const checkEmail = (email: any) => {
    return request('head', `/api/rubik/account/email/${email}`, null, null, true)
}

// 外部认证结果处理
export const externalCallback = (provider: string, params: any) => {
    return request('get', `/api/rubik/account/external/${provider}/callback`, params)
}

// 外部认证结果获取
export const externalResult = (stateId: string) => {
    return request('get', `/api/rubik/account/external/auth/result/${stateId}`)
}

// 用户名密码登录
export const tokenUserNamePassword = (params: any) => {
    return request('post', `/api/rubik/token/username_password`, params, null, true)
}

// 手机号码登录
export const tokenMobilePassword = (params: any) => {
    return request('post', `/api/rubik/token/mobile_password`, params)
}

// 手机号码验证
export const tokenMobileCheck = (params: any) => {
    return request('post', `/api/rubik/token/mobile_check`, params)
}

// 邮箱登录
export const tokenEmailPassword = (params: any) => {
    return request('post', `/api/rubik/token/email_password`, params)
}

// 邮箱验证
export const tokenEmailCheck = (params: any) => {
    return request('post', `/api/rubik/token/email_check`, params)
}

// 退出登录
export const tokenDelete = () => {
    return request('delete', `/api/rubik/token`)
}


// 当前用户信息
export const myself = () => {
    return request('get', `/api/rubik/myself`)
}


